export default __webpack_public_path__ + "static/media/black-bag.368c821c.svg";